var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _vm.resTags.length > 0 ? _c('div', _vm._b({ staticClass: "multi-cascader" }, 'div', _vm.innerConfig.params.referenceAttrs, false), [_c('el-cascader', _vm._g(_vm._b({ attrs: { "options": _vm.resTags, "props": _vm.cascaderProps }, model: { value: _vm.formValue[_vm.innerConfig.prop], callback: function callback($$v) {
        _vm.$set(_vm.formValue, _vm.innerConfig.prop, $$v);
      }, expression: "formValue[innerConfig.prop]" } }, 'el-cascader', _vm.innerConfig.params, false), _vm.$listeners))], 1) : _vm._e();
};
var staticRenderFns = [];

export { render, staticRenderFns };